import treeOfModal from './treeOfModal.vue'
export default treeOfModal
